import React from 'react';

export const PDFIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M0.666626 2C0.666626 0.90625 1.54163 0 2.66663 0H7.66663V4C7.66663 4.5625 8.10413 5 8.66663 5H12.6666V9.5H6.16663C5.04163 9.5 4.16663 10.4062 4.16663 11.5V16H2.66663C1.54163 16 0.666626 15.125 0.666626 14V2ZM12.6666 4H8.66663V0L12.6666 4ZM6.16663 11H7.16663C8.10413 11 8.91663 11.8125 8.91663 12.75C8.91663 13.7188 8.10413 14.5 7.16663 14.5H6.66663V15.5C6.66663 15.7812 6.41663 16 6.16663 16C5.88538 16 5.66663 15.7812 5.66663 15.5V14V11.5C5.66663 11.25 5.88538 11 6.16663 11ZM7.16663 13.5C7.57288 13.5 7.91663 13.1875 7.91663 12.75C7.91663 12.3438 7.57288 12 7.16663 12H6.66663V13.5H7.16663ZM10.1666 11H11.1666C11.9791 11 12.6666 11.6875 12.6666 12.5V14.5C12.6666 15.3438 11.9791 16 11.1666 16H10.1666C9.88538 16 9.66663 15.7812 9.66663 15.5V11.5C9.66663 11.25 9.88538 11 10.1666 11ZM11.1666 15C11.4166 15 11.6666 14.7812 11.6666 14.5V12.5C11.6666 12.25 11.4166 12 11.1666 12H10.6666V15H11.1666ZM13.6666 11.5C13.6666 11.25 13.8854 11 14.1666 11H15.6666C15.9166 11 16.1666 11.25 16.1666 11.5C16.1666 11.7812 15.9166 12 15.6666 12H14.6666V13H15.6666C15.9166 13 16.1666 13.25 16.1666 13.5C16.1666 13.7812 15.9166 14 15.6666 14H14.6666V15.5C14.6666 15.7812 14.4166 16 14.1666 16C13.8854 16 13.6666 15.7812 13.6666 15.5V13.5V11.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
